module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2011 by Julian Guthrie")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Guthrie, Julian."), _c('br'), _vm._v("\nThe grace of everyday saints : how a band of believers lost"), _c('br'), _vm._v("\ntheir church and found their faith / Julian Guthrie."), _c('br'), _vm._v("\np. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-13304-1")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("1. St. Brigid Catholic Church (San Francisco, Calif.)—History. 2. San Francisco (Calif.)—Church history. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BX")]), _vm._v("4603."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v("5"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("G")]), _vm._v("88 2011"), _c('br'), _vm._v("\n282’.7946109049—dc22"), _c('br'), _vm._v("\n2010049819")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("eISBN 978-0-547-52361-3"), _c('br'), _vm._v("\nv2.0421")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0